module.exports = __webpack_public_path__ + "static/media/mediumplating.8427db4f.png";